export const environment = {
  production: false,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
  // baseUrl: 'http://localhost:8034/api',
  baseUrl: 'https://dash.connectxpert.com.au/api',
  micrositeApiUrl: 'https://helathinsurancefind.com.au/api',
  // Google sign-in. A client id is public by design, not a secret: the
  // browser verifies an ID token against Google public keys, so there is
  // no code exchange and no client secret anywhere. Empty hides the button.
  googleClientId: '188203233239-umm8mmi4eeijs8qorc4b2d6hbnukg5uo.apps.googleusercontent.com',
};
